import type { SVGProps } from 'react'

export const LeftCircleIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M560-280q-8 0-14-3t-11-9L367-470q-4-4-5.5-8.5T360-488q0-5 1.5-9.5T367-506l168-178q5-6 11.5-9t13.5-3q14 0 23.5 9.5T593-663q0 7-2.5 13T583-639L430-480l153 159q5 6 7.5 12t2.5 13q0 14-9.5 23T560-280Z" />
    </svg>
  )
}
